import authenticationPlugin from './authenticationPlugin'

export default {
  strict: true,
  state: {
    logoutConfirmation: {
      show: false
    }
  },
  mutations: {
    SHOW_LOGOUT_CONFIRMATION(state) {
      state.logoutConfirmation.show = true
    },
    HIDE_LOGOUT_CONFIRMATION(state) {
      state.logoutConfirmation.show = false
    }
  },
  actions: {
    showLogoutConfirmation({ commit }) {
      commit('SHOW_LOGOUT_CONFIRMATION')
    },
    hideLogoutConfirmation({ commit }) {
      commit('HIDE_LOGOUT_CONFIRMATION')
    }
  },
  plugins: [authenticationPlugin]
}
